module.exports = __webpack_public_path__ + "img/fas-ellipsis-vertical.fd1354b3.svg";